import { combineReducers } from "redux";
import withdraw_request from "../features/admin/driver_wallet/withdraw_request/slice";
import wallet_history from "../features/admin/driver_wallet/wallet_history/slice";
import wallet_payment from "../features/admin/driver_wallet/wallet_payment/slice";
import wallet_fund_add_request from "../features/admin/driver_wallet/wallet_fund_add_request/slice";

const BookingManagement = combineReducers({
  withdraw_request: withdraw_request,
  wallet_history: wallet_history,
  wallet_payment: wallet_payment,
  wallet_fund_add_request: wallet_fund_add_request,
});

export default BookingManagement;
